import React from 'react';

const decodeHtmlEntities = (text: string): string => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};

export const FormattedText: React.FC<{ text: string }> = ({ text }) => {
    const decodedText = decodeHtmlEntities(text);

    return (
        decodedText.match(/\n{2,}/) ? 
            decodedText.split(/\n{2,}/).map((line: string, index: number) => (
                <p key={index}>
                    {line.split('\n').map((subline, subIndex) => (
                        <React.Fragment key={subIndex}>
                            {subline}
                            {subIndex < line.split('\n').length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </p>
            ))
            :
            <>{decodedText.split('\n').reduce((acc: React.ReactNode[], line, i) => 
                i === 0 ? [line] : [...acc, <br key={i} />, line], []
            )}</>
    );
};

export default FormattedText;